/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.educator-growth.mentors-and-evaluators'},
});

const MentorsAndEvaluatorsItem = () => (
  <RouteLinkItem
    route="midas/settings/educator-growth/mentors-and-evaluators"
    title={messages.title}
  />
);

export default MentorsAndEvaluatorsItem;
